import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { EnvironmentsEnum } from '../enum/environments-enum';
import { environment } from '../../environments/environment';

@Directive({
    selector: '[otbShowInEnv]',
    standalone: false,
})
export class ShowInEnvDirective {
    private readonly env: EnvironmentsEnum;
    @Input() set otbShowInEnv(envs: string[]) {
        if (envs.includes(this.env)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
    ) {
        this.env = <EnvironmentsEnum>environment.deploy_environment;
    }
}
